import React from 'react';
import { TabsOption } from 'global';
import { Box } from '@mui/material';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { FeatureFlags, PortalConfigContainer } from 'modules/portalConfigurations';

import { ListOfTemplates } from '../../BPF';
import { VendorProfileSettingsContainer } from 'modules/portalSetup';
import OcaLenderSettingsCard from './ocaLenderSettings/OcaLenderSettingsCard';

export const LenderPortalSetup = () => {
  const tabs: TabsOption[] = [
    {
      label: 'General',
      value: 'general',
      urlAnchor: '#general',
      component: (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', paddingTop: '1rem' }}>
          <PortalConfigContainer portalConfigTypes={[PortalConfigurationType.LenderFeatureFlags]}>
            {options => <FeatureFlags {...options} />}
          </PortalConfigContainer>
          <VendorProfileSettingsContainer>
            {options => <OcaLenderSettingsCard {...options} />}
          </VendorProfileSettingsContainer>
        </Box>
      ),
    },
    {
      value: 'stages',
      urlAnchor: '#stages',
      label: 'Opportunity Stages',
      component: <ListOfTemplates />,
    },
  ];

  return (
    <PageContainer title="Portal Setup">
      <TabsContainer tabs={tabs} isSyncWithAnchor TabsLabelWrapper={CardBackground} />
    </PageContainer>
  );
};
